/**
 * Shapes a raw `enumerateDevices()` result into the camera list the picker
 * renders. `isCurrent` is a plain boolean comparison — never an unguarded
 * `.find(...).value` dereference (the old utilis/helpers.js `getMediaDevices`
 * threw a TypeError whenever no enumerated device matched the active
 * stream's deviceId; here that case just yields `isCurrent: false` for every
 * entry, which is a real possible state, not a bug).
 *
 * Every camera is kept (not deduped by groupId like the old implementation
 * did) — two physically distinct cameras can legitimately share a groupId on
 * some multi-camera modules, and dropping one from the picker silently is
 * worse than showing a harmless duplicate-looking label.
 */
export function buildCameraList(devices, currentDeviceId) {
  const videoInputs = (devices ?? []).filter(device => device.kind === 'videoinput');

  return videoInputs.map((device, index) => {
    const hasNativeLabel = Boolean(device.label?.trim());

    return {
      deviceId: device.deviceId,
      groupId: device.groupId,
      // iOS commonly reports blank labels until/unless permission has been
      // granted for a while — a friendly numbered fallback beats an empty row.
      label: hasNativeLabel ? device.label : `Camera ${index + 1}`,
      hasNativeLabel,
      isCurrent: Boolean(currentDeviceId) && device.deviceId === currentDeviceId,
    };
  });
}
